import { UserInfo, ChangePasswordDialogProgress, SiteRole } from '../types';

export type UserState = {
    loading: boolean;
    success: boolean;
    message: string;
    loggedInUser: UserInfo;
    emailLoading: boolean;
    smsLoading: boolean;
    sessionLoading: boolean;
    userDetailLoading: boolean;
    updateSuccess: boolean;
    updateRoleLoading: boolean;
    updateRoleSuccess: boolean;
    updatedRolesSites: SiteRole[];
    changePassword: {
        loading: boolean;
        progress: ChangePasswordDialogProgress;
    };
};
export const roleSiteUser: SiteRole = {
    roleId: '',
    siteIds: [''],
};
export const initialUserInfo: UserInfo = {
    user: { fName: '', lName: '', email: '', phone: '' },
    notification: { emailenabled: false, smsenabled: false },
    session: { sessionEnabled: true },
};
export const initialUserState: UserState = {
    loading: false,
    success: false,
    message: '',
    emailLoading: false,
    smsLoading: false,
    sessionLoading: false,
    userDetailLoading: false,
    updateSuccess: false,
    loggedInUser: initialUserInfo,
    updateRoleLoading: false,
    updateRoleSuccess: false,
    updatedRolesSites: [roleSiteUser],
    changePassword: {
        loading: false,
        progress: ChangePasswordDialogProgress.Initial,
    },
};
